import { render } from "./TitleBoxWidgetConfig.vue?vue&type=template&id=000042c4&scoped=true"
import script from "./TitleBoxWidgetConfig.vue?vue&type=script&lang=js"
export * from "./TitleBoxWidgetConfig.vue?vue&type=script&lang=js"

import "./TitleBoxWidgetConfig.vue?vue&type=style&index=0&id=000042c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000042c4"],['__file',"src/containers/widget/configs/TitleBoxWidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "000042c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('000042c4', __exports__)) {
    api.reload('000042c4', __exports__)
  }
  
  module.hot.accept("./TitleBoxWidgetConfig.vue?vue&type=template&id=000042c4&scoped=true", () => {
    api.rerender('000042c4', render)
  })

}


export default __exports__